import styled from '@emotion/styled/macro';

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 400px;
`;

export const Title = styled.h1`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.xlarge};
    color: ${props => props.theme.colours.textGreen};
`;
